<div style="overflow: auto;">
  <div class="ui-g page-header-c mt-10">
    <div class="ui-g-12 ui-md-6 ui-lg-6">
      <h1 class="page-title" translate>Manage Shift
      </h1>
    </div>
  </div>
  
  <div class="booking-details-header pb-30 mt-5">
  
    <div class="ui-g mobile-booking-wrapper">
      <div class="ui-g-4 ui-sm-4 label-wrapper">
        <div class="shift-leble" translate>Team Member </div>
        <div class="shift-value">
          <div *ngIf="firstName"> {{ shiftDetails?.firstName }} {{shiftDetails?.lastName}}</div>
          <div *ngIf="!firstName"> -- </div>
        </div>
      </div>
  
      <!-- todo: edit team get api remove -->
      <!-- <div class="ui-g-4 ui-sm-4" *ngIf="shiftDetails?.team && shiftDetails?.team?.length !== 0">
        <div class="shift-leble" translate> Team </div>
        <div class="shift-value">
          <div *ngIf="title"> {{ shiftDetails?.team }} </div>
          <div *ngIf="!title"> -- </div>
        </div>
      </div> -->
  
      <div class="ui-g-4 ui-sm-4 label-wrapper">
        <div class="shift-leble" translate> Shift Date </div>
        <div class="shift-value">
         <!--  <div> {{ shiftDetails?.date ? shiftDetails?.date : '--' }} </div> -->
         <p-calendar [(ngModel)]="dateCalender" [ngModelOptions]="{standalone: true}" (onSelect)="onDateChange($event)" placeholder="--" [dateFormat]="'mm/dd/yy'" [showIcon]="true"></p-calendar>
        </div>
      </div>
  
  
    </div>
  
    <div class="ui-g mt-10">
  
      <div class="ui-g-12 ui-sm-12 shift-time-details">
        <div class="shift-time-container">
          <div class="shift-time-header">
            <span class="shift-time"> Shift Time </span>
            <span accessCode="PROVIDERS_UPDATE_USER" class="delete-schedule"
              *ngIf="tempUserSchedules.length > 0 && !isPreviousDate" title="Delete Schedule"
              (click)="deleteSchedule($event)">
              <img src="/assets/images/temp/delete.svg">
            </span>
  
            <span accessCode="PROVIDERS_UPDATE_USER" class="edit-schedule"
              *ngIf="tempUserSchedules.length > 0 && !isEditable && !isPreviousDate" title="Edit Schedule"
              (click)="editSchedule($event)">
              <img src="/assets/images/temp/edit.svg">
            </span>
          </div>
          <div *ngIf="schedulesUserList">
            <div class="shift-time-list border-bottom ui-g" *ngIf="manageScheduleForm.get('items').controls.length === 0">
              <div class="ui-g-8 no-shift-wrapper">
                No shift available
              </div>
              <div class="ui-g-4" style="text-align: right;">
                <span accessCode="IMPORT_PROVIDER_SCHEDULES" *ngIf="tempUserSchedules.length === 0 && !isPreviousDate"
                  title="Add" class="plus-icon" (click)="addItem();isEditable=true; isSaveEnable=true">
                  <img src="/assets/images/temp/plus.png">
                </span>
              </div>
            </div>
            <div class="shift-time-list ui-g">
              <form [formGroup]="manageScheduleForm">
                <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
                <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad" formArrayName="items">
                  <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad"
                    *ngFor="let item of manageScheduleForm.get('items').controls; let i = index;">
                    <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad" [formGroupName]="i">
                      <div class="form-control-c ui-g-4 ui-md-4 ui-lg-3 timeoff-wrap">
                        <div class="timeoff" *ngIf="isLeaveSchedule(userSchedules[i])">Leave Type: <span
                          class="red-text">{{getLeaveTypeLabel(userSchedules[i])}}</span></div>
                          <div class="timeoff duty-color" *ngIf="userSchedules[i]?.source === 'DUTY_ON_OFF'" translate>label_duty_on_off</div>
                          <p-calendar class="schedule-calender" (onBlur)="getTime(item,i)"  [disabled]="!isEditable || userSchedules[i]?.source === 'DUTY_ON_OFF'" formControlName="availableFrom" hourFormat="12" [showIcon]="true" [timeOnly]="true"
                          [stepMinute]="15" [defaultDate]="currentDate" placeholder="Start Time"></p-calendar>
                       </div>
                       <div class="form-control-c ui-g-4 ui-md-4 ui-lg-3">
                         <p-calendar class="schedule-calender" id="availableTo"  [disabled]="!isEditable || userSchedules[i]?.source === 'DUTY_ON_OFF'" formControlName="availableTo" hourFormat="12" [showIcon]="true" [timeOnly]="true" (onBlur)="getEndTime(item,i)"
                          [stepMinute]="15" [defaultDate]="currentDate" placeholder="End Time"></p-calendar>
                       </div> 
                      <div class="form-control-c custom-dropdown ui-g-6 ui-md-6 ui-lg-3" *ngIf="!isWebPortalUser">
                        <p-dropdown autocomplete="off" [options]="teamList" [style]="{'width': '100%', border: '1px solid #CECFD4'}" filter="filter"
                           formControlName="team" 
                           [disabled]="!isEditable || userSchedules[i]?.source === 'DUTY_ON_OFF' || userSchedules[i]?.leaveType	 === 'PTO'">
                        </p-dropdown>
                      </div>
                     
                      <div class="form-control-c ui-g-4 ui-md-4 ui-lg-3 field-btns" *ngIf="isEditable">
                        <span accessCode="PROVIDERS_ADD_MULTI_PROVIDERS_SCHEDULE"  title="Remove" *ngIf="manageScheduleForm.get('items').controls.length !== 1" class="minus-icon" (click)="removeItem(i,userSchedules[i]?.id, isLeaveSchedule(userSchedules[i]))" [ngClass]="{'disabled': userSchedules[i]?.source === 'DUTY_ON_OFF'}"
                        >
                          <img src="/assets/images/temp/minus.png">
                        </span>
                        <span accessCode="PROVIDERS_ADD_MULTI_PROVIDERS_SCHEDULE"  title="Add" *ngIf="manageScheduleForm.get('items').controls.length - 1 === i" class="plus-icon" (click)="addItem()">
                          <img src="/assets/images/temp/plus.png">
                        </span>
                      </div>
                    
                    </div>
                    
                  </div>

                  <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad" *ngIf="userRoleId == 4 && leaveNotesIndex >= 0" [formGroupName]="leaveNotesIndex">
                    <div class="form-control-c" style="width:75%">
                      <div class="shift-leble" translate> Notes </div>
                      <textarea
                        formControlName="notesChange"
                        [ngClass]="{ 'disabled-textarea': !isEditable }"
                        (input)="onNotesChange($event, leaveNotesIndex)"
                        placeholder="Enter notes"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
                
                  <div class="ui-g-12 ui-g-nopad">
  
                    <div class="form-buttons ui-g-12">
                      <button pButton class="save-btn" type="button" [label]="'label_save' | translate"
                        (click)="updateSchedular()" [disabled]="manageScheduleForm.invalid || isDisable"></button>
                      <button class="cancel-btn" pButton type="button" [label]="'label_cancel' | translate"
                        (click)="onCancel()"></button>
                    </div>
                  </div>
                </div>
  
              </form>
            </div>
            <!-- Shedular Start -->
            <!-- <div class="shift-time-list ui-g">
              <form [formGroup]="manageScheduleForm">
                <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
                  <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad" formArrayName="items"
                    *ngFor="let item of manageScheduleForm.get('items').controls; let i = index;">
                    <div class="form-field ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad calendar-wrap" [formGroupName]="i">
                      <div class="form-control-c ui-g-6 ui-md-6 ui-lg-3 timeoff-wrap"
                        [class.red]="userSchedules[i]?.leaveType">
                        <p-calendar class="schedule-calender" [disabled]="!isEditable || userSchedules[i]?.leaveType"
                          formControlName="availableFrom" hourFormat="12" [showIcon]="true" [timeOnly]="true"
                          [stepMinute]="15" (onBlur)="getTime(item,i)" [defaultDate]="currentDate"
                          placeholder="Start Time" icon="pi pi-clock"></p-calendar>
                      </div>
  
                      <div class="form-control-c ui-g-6 ui-md-6 ui-lg-3" [class.red]="userSchedules[i]?.leaveType">
                        <p-calendar class="schedule-calender" [disabled]="!isEditable || userSchedules[i]?.leaveType"
                          formControlName="availableTo" hourFormat="12" [showIcon]="true" [timeOnly]="true"
                          [stepMinute]="15" (onBlur)="getEndTime(item,i)" [defaultDate]="currentDate"
                          placeholder="End Time" icon="pi pi-clock"></p-calendar>
                      </div>
                      <div class="form-control-c custom-dropdown ui-g-6 ui-md-6 ui-lg-3"
                        *ngIf="userRoleId == 4 && !userSchedules[i]?.leaveType ">
                        <p-dropdown autocomplete="off" [options]="teamList"
                          [style]="{'width': '100%', border: '1px solid #CECFD4'}" filter="filter" formControlName="team"
                          [disabled]="!isEditable || userSchedules[i]?.leaveType">
                        </p-dropdown>
                      </div>
  
                      <div class="ui-g-4 ui-md-4 ui-lg-3 timeoff" *ngIf="userSchedules[i]?.leaveType"><span
                          class="red-text">{{userSchedules[i]?.leaveType}}</span></div>
  
                      <div class="form-control-c ui-g-4 ui-md-4 ui-lg-3 field-btns custom-dropdown" *ngIf="isEditable">
                        <span accessCode="PROVIDERS_UPDATE_USER" title="Remove"
                          *ngIf="manageScheduleForm.get('items').controls.length !== 1" class="minus-icon"
                          (click)="removeItem(i, userSchedules[i]?.id, userSchedules[i]?.leaveType)">
                          <img src="/assets/images/temp/minus.png">
                        </span>
                        <span accessCode="PROVIDERS_UPDATE_USER" title="Add"
                          *ngIf="manageScheduleForm.get('items').controls.length - 1 === i" class="plus-icon"
                          (click)="addItem();isSaveEnable=true">
                          <img src="/assets/images/temp/plus.png">
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="ui-g-12 ui-g-nopad">
  
                    <div class="form-buttons ui-g-12">
                      <button pButton class="save-btn" type="button" [label]="'label_save' | translate"
                        [disabled]="!manageScheduleForm.valid || !isSaveEnable" (click)="updateSchedular()"></button>
                      <button class="cancel-btn" pButton type="button" [label]="'label_cancel' | translate"
                        (click)="onCancel()"></button>
                    </div>
                  </div>
                </div>
              </form>
            </div> -->
            <!-- Schedular End -->
          </div>
        </div>
  
      </div>
    </div>
  </div>
</div>
